import { useCallback } from "react";
import {
  RegistryLayoutStoreActions,
  useRegistryLayoutDispatch,
} from "../useRegistryLayoutStore";

export const useToggleCaseView = (): (() => void) => {
  const dispatch = useRegistryLayoutDispatch();

  const callFn = useCallback(() => {
    dispatch({
      type: RegistryLayoutStoreActions.toggleCaseView,
    });
  }, [dispatch]);

  return callFn;
};
